import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class ConfigService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._config = {};
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new ConfigService(singletonEnforcer);
    }
    return this[singleton];
  }

  get(key) {
    return this._config[key] ? this._config[key] : null;
  }

  set(key, value) {
    this._config[key] = value;
  }

  parse(config) {
    if(config.notice_collection_code) {
      this.set('isCollectionView', true);
      this.set('noticeCollectionsFilter', config.notice_collection_code);
     }

    if (config.render.show_only_notice_with_image !== undefined) this.set('onlyHasImage', config.render.show_only_notice_with_image);
    if (config.render.mode_list_notices !== undefined) this.set('renderMode', config.render.mode_list_notices);
    if (config.render.zoom_thumbnail !== undefined) this.set('zoomThumbnail', config.render.zoom_thumbnail);
    if (config.render.search_enabled !== undefined) this.set('searchEnabled', config.render.search_enabled);
    if (config.render.show_randomly_default_notice_list !== undefined) this.set('randomize', config.render.show_randomly_default_notice_list);
    if (config.render.show_most_views_notices !== undefined) this.set('showMostViewsNotices', config.render.show_most_views_notices);
  }

}
export default ConfigService.getInstance();